import { render, staticRenderFns } from "./broker.vue?vue&type=template&id=02e477a1"
import script from "./broker.vue?vue&type=script&lang=js"
export * from "./broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports